<template>
    <Button class="ml-2" v-if="exibirBotaoClassificarParcelas" icon="pi pi-link" label="Classificar parcelas" @click="showDialog()" />

    <Dialog v-model:visible="this.display" :maximizable="false" :style="{ width: '40vw' }" no-close-on-backdrop>
        <template #header>
            <h3>Classificar - Parcelas</h3>
        </template>
        <div class="formgrid grid p-fluid">
            <div class="field col">
                <label class="required">Unidades</label>
                <Dropdown
                    v-model="codUnidade"
                    :filter="true"
                    :options="this.unidadesRm"
                    placeholder="Selecione"
                    optionLabel="nome"
                    optionValue="codUnidade"
                    @change="carregarProjetosRm(true)"
                />
            </div>
        </div>
        <div class="formgrid grid p-fluid">
            <div class="field col">
                <label class="required">Projeto</label>
                <Dropdown
                    v-model="codProjeto"
                    :filter="true"
                    :options="this.projetosRm"
                    placeholder="Selecione"
                    optionLabel="nome"
                    optionValue="codProjeto"
                    @change="carregarAcoes(true)"
                />
            </div>
        </div>
        <div class="formgrid grid p-fluid">
            <div class="field col">
                <label class="required">Ação</label>
                <Dropdown v-model="codAcao" :filter="true" :options="this.acoes" placeholder="Selecione" optionLabel="nome" optionValue="codAcao" />
            </div>
        </div>
        <div class="grid">
            <div class="col-12">
                <tabela :data="parcelas" datakey="classificarParcelas" v-model:selection="selectedParcelas">
                    <template #conteudo>
                        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                        <Column :sortable="true" field="parcela" header="Parcela" headerStyle="width: 6em">
                            <template #body="slotProps">
                                {{ slotProps.data.parcela }}
                            </template>
                        </Column>
                        <Column :sortable="true" field="valor" header="Valor">
                            <template #body="slotProps">
                                {{ slotProps.data.valorFormatado }}
                            </template>
                        </Column>
                        <Column :sortable="true" field="dataVencimento" header="Vencimento">
                            <template #body="slotProps">
                                {{ slotProps.data.dataVencimentoFormatada }}
                            </template>
                        </Column>
                        <Column :sortable="true" field="formaPagamento" header="Forma de Pagamento">
                            <template #body="slotProps">
                                {{ slotProps.data.formaPagamento }}
                            </template>
                        </Column>
                        <Column :sortable="true" field="statusPagamentoDescricao" header="Status">
                            <template #body="slotProps">
                                <status :status="slotProps.data.statusPagamentoDescricao"></status>
                            </template>
                        </Column>
                    </template>
                </tabela>
            </div>
        </div>
        <template #footer>
            <Button :disabled="v$.$invalid" label="Salvar" @click="salvar()" />
            <Button autofocus label="Fechar" @click="closeDialog" />
        </template>
    </Dialog>
</template>

<script>
import Services from '../../service.js';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    props: {
        parcelas: {
            type: Object,
        },
        parceria: {
            type: Object,
        },
    },
    setup() {
        return { v$: useVuelidate() };
    },

    validations() {
        return {
            codUnidade: { required },
            codAcao: { required },
            codProjeto: { required },
            listagemParcelasSelecionadas: { required },
        };
    },

    data() {
        return {
            display: false,
            unidadesRm: [],
            codUnidade: null,
            acoes: [],
            codAcao: null,
            projetosRm: [],
            codProjeto: null,
            selectedParcelas: [],
            listagemParcelasSelecionadas: [],
        };
    },

    methods: {
        showDialog() {
            this.display = true;
            this.limpar();
            this.carregarUnidadesRm();
        },
        closeDialog() {
            this.limpar();
            this.display = false;
        },
        carregarUnidadesRm() {
            this.$store.dispatch('addRequest');
            Services.obterUnidadesRm().then((response) => {
                if (response && response.success) {
                    this.unidadesRm = response.data;
                } else {
                    this.unidadesRm = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },
        carregarProjetosRm(deixarCodProjetoNulo = false) {
            if (deixarCodProjetoNulo) {
                this.codProjeto = null;
            }
            this.$store.dispatch('addRequest');
            Services.obterProjetos(this.codUnidade).then((response) => {
                if (response && response.success) {
                    this.projetosRm = response.data;
                } else {
                    this.projetosRm = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },
        carregarAcoes(deixarCodAcoesNulo = false) {
            if (deixarCodAcoesNulo) {
                this.codAcao = null;
            }
            this.$store.dispatch('addRequest');
            Services.obterAcoes(this.codUnidade, this.codProjeto).then((response) => {
                if (response && response.success) {
                    this.acoes = response.data;
                } else {
                    this.acoes = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },
        obterParcelasSelecionadas() {
            this.listagemParcelasSelecionadas = this.selectedParcelas.map((parcela) => parcela.id);
        },
        limpar() {
            this.codUnidade = null;
            this.codProjeto = null;
            this.codAcao = null;
            this.selectedParcelas = [];
            this.listagemParcelasSelecionadas = [];
        },
        salvar() {
            this.$store.dispatch('addRequest');
            const dtoParaClassificarParcelas = {
                parcelasId: this.listagemParcelasSelecionadas,
                codAcao: this.codAcao,
                codUnidade: this.codUnidade,
                codProjeto: this.codProjeto,
            };
            Services.classificarParcelas(dtoParaClassificarParcelas).finally(() => {
                this.$toast.add({
                    severity: 'success',
                    summary: 'Classificar parcelas',
                    detail: 'Classificação realizada com sucesso',
                    life: 6000,
                });
                this.$store.dispatch('removeRequest');
                this.closeDialog();
            });
        },
    },

    computed: {
        openDialog() {
            return this.show || this.display;
        },
        exibirBotaoClassificarParcelas() {
            return this.parcelas != null && this.parcelas.length > 0 && this.parceria?.status == 0;
        },
    },

    watch: {
        show() {
            this.dipslay = this.show;
        },
        codProjeto() {
            if (this.codProjeto != null) {
                this.carregarProjetosRm(false);
                this.carregarAcoes();
            }
        },
        selectedParcelas() {
            this.obterParcelasSelecionadas(this.selectedParcelas);
        },
    },

    mounted() {
        this.openDialog = this.show;
    },
};
</script>
